module.exports = __webpack_public_path__ + "img/country-pattern.a8e88bde.svg";